import { Button, Modal, Typography } from "@/components/atoms";

interface RemoveDriverModalProps {
  open: boolean;
  driverName: string;
  onClose: () => void;
  onRemove: () => void;
}

export const RemoveDriverModal = ({ open, driverName, onClose, onRemove }: RemoveDriverModalProps) => {
  return (
    <Modal open={open} onClose={onClose} className="w-[85vw] !p-6 md:w-[400px] lg:w-[400px]">
      <div className="flex flex-col">
        <Typography variant="title">Remove {driverName}</Typography>
        <Typography variant="paragraph" className="mt-3 text-neutral-dark-gray">
          Are you sure you want to remove <span className="text-info">{driverName}</span>&apos;s access to your vehicle? This will prevent them from using this vehicle for job bookings.
        </Typography>
        <div className="mt-6 flex justify-end gap-4">
          <Button variant="secondary" size="md" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" size="md" className="!bg-danger !text-white hover:!bg-danger-dark" onClick={onRemove}>
            Remove
          </Button>
        </div>
      </div>
    </Modal>
  );
};
